let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9elLh")).then(() => parcelRequire('8Tuck'));